module.exports = __webpack_public_path__ + "17_hair_silver.350764db.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/17_hair_silver.png
// module id = 80lW
// module chunks = 0